import {
  SURVEY_REPORT_GET_RES,
  SURVEY_REPORT_GET_BACKUP,
  SURVEY_REPORT_LOAD
} from '../actions';

const INIT_STATE = {
  respoArr: [],
  demoArr: [],
  respoPure: null,
  demoPure: null,
  loading: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SURVEY_REPORT_GET_RES:
      if (action.payload.res != null && action.payload.demo == null) {
        return { ...state, respoArr: action.payload.res, loading: true };
      } else if (action.payload.res == null && action.payload.demo != null) {
        return { ...state, demoArr: action.payload.demo, loading: true };
      }
      return { ...state, respoArr: [], demoArr: [], loading: true };
    case SURVEY_REPORT_GET_BACKUP:
      if (action.payload.res != null && action.payload.demo == null) {
        return { ...state, respoPure: action.payload.res, loading: true };
      } else if (action.payload.res == null && action.payload.demo != null) {
        return { ...state, demoPure: action.payload.demo, loading: true };
      }
      return { ...state, respoPure: null, demoPure: null, loading: true };
    case SURVEY_REPORT_LOAD:
      return { ...state, loading: action.payload };
    default:
      return { ...state };
  }
};
